export const ONE_CLICK_SIGN_IN_LOGIN_HISTORY_COOKIE = "_signInHistory";
export const ONE_CLICK_SIGN_IN_COOKIE = "_oneClickSignIn";
export const ONE_CLICK_SIGN_IN_LOGIN_PAGE_URL = "https://dashboard.brex.com/";
export const ONE_CLICK_SIGN_IN_MAX_AGE_MS = 2 * 24 * 60 * 60 * 1000;
export const ONE_CLICK_SIGN_IN_MIN_LOGIN_COUNT = 1;
export const ONE_CLICK_SIGN_IN_OPT_IN_COOKIE_EXPIRY_DAYS = 365;
export const ONE_CLICK_SIGN_IN_OPT_OUT_COOKIE_EXPIRY_DAYS = 365;
